// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3FSAs","title":"ClientInsurance_title__3SNpZ","itemText":"ClientInsurance_itemText__1nb_g"};